'use client';
import type { InterfaceEntity } from '@unifyapps/defs/types/interface';
import type { UseFetchResourcesHookType } from '../../../types';
import { useGetAuthDeployedInterfaceById } from '../useAuthDeployedInterface';
import { useAuthPageResourcesFromRecord } from '../useFetchAuthDeployedInterfaceResources/useAuthPageResourcesFromRecord';

/**
 * PlatformAuthorization strategy — platform auth pages (login/forgot/reset/update/mfa) rendered
 * pre-auth. Resolves the `ua-platform` interface record by explicit id through the public,
 * session-free `/auth/interface/deployed/{id}` route (no domain/host lookup, no authenticated
 * entity route — those would 401-loop before a session exists), then runs the shared auth page tail.
 */
const useFetchPlatformAuthDeployedInterfaceResources: UseFetchResourcesHookType = ({
  interfaceId,
  interfaceComponent,
  mode,
}) => {
  const platformAuthInterface = useGetAuthDeployedInterfaceById<InterfaceEntity>(interfaceId, {
    query: {
      enabled: Boolean(interfaceId),
      staleTime: Infinity,
    },
  });

  return useAuthPageResourcesFromRecord({
    interfaceRecord: platformAuthInterface.data,
    isLoadingInterfaceRecord: platformAuthInterface.isLoading,
    errorInterfaceRecord: platformAuthInterface.error,
    interfaceComponent,
    mode,
  });
};

export default useFetchPlatformAuthDeployedInterfaceResources;
